
export const strToHex = (str) =>{
  // encode each character to a byte, then to 2-digit hex
  return Array
    .from(new TextEncoder().encode(str))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

export const formatAddress = (value) => {
  if (value == undefined || value == "" || value == null) return "";
  return value.substring(0,4) + "..." + value.substring(value.length -4,);
}

export const combineAddress = (address1, address2) => {
  const addr1 = formatAddressMicroText(address1);
  const addr2 = formatAddressMicroText(address2);
  if (addr1 > addr2) return addr1 + addr2;
  else return addr2 + addr1;
}

export const formatAddressMicro = (value) => {
  return value.substring(0,6) + "..." + value.substring(value.length -6,);
}

export const formatAddressMicroText = (value) => {
  return value.substring(0,6) + value.substring(value.length -6,);
}

export const formatAddressMini = (value) => {
  if (value == "") return "-";
  return value.substring(value.length -6,);
}

export const formatInscriptionId = (value) => {
  if (value == "" || value == undefined) return "-";
  return value.substring(0,12) + "..." + value.substring(value.length -12,);
}

export const formatInscriptionIdMini = (value) => {
  if (value == "" || value == undefined) return "-";
  return value.substring(0,8) + "..." + value.substring(value.length -8,);
}

export const formatTime = (value) => {
  return value.substring(0, 10) + " " + value.substring(11, 16);
}

export const formatDate = (timestamp) => {
  const date = new Date(timestamp * 1000);

  // Extract the different parts of the date
  const year = date.getFullYear();
  const month = date.toLocaleString('default', { month: 'short' });
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes().toString().padStart(2, '0');
  const amPm = hour >= 12 ? 'PM' : 'AM';
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12; // Convert 24h to 12h format

  // Format the date as "Dec 14, 2023, 6:23 PM"
  const formattedDate = `${month} ${day}, ${year}, ${formattedHour}:${minute} ${amPm}`;

  return formattedDate;
}

export const getAsciiSum = (str) => {
  let sum = 0;
  for(let i = 0; i < str.length; i++)
  {
    sum = sum + str.charCodeAt(i);
  }
  return sum;
} 

export const formatUnixTime = (dateStr) => {
  if (dateStr == undefined || dateStr == null) return "";
  if (dateStr.length > 12) return dateStr.split(' ')[0];
  else {
    let unixTimestamp;
    if (dateStr.includes(".")) unixTimestamp = Math.floor(parseFloat(dateStr) * 1000);
    else unixTimestamp = parseInt(dateStr);
    const date = new Date(unixTimestamp * 1000);
    const formattedDate = 
      date.getFullYear() + '-' + 
      ('0' + (date.getMonth() + 1)).slice(-2) + '-' + 
      ('0' + date.getDate()).slice(-2)

    return formattedDate; 
  }
}

export const amountFormat = (num) => {
  const formattedNumber = num.toLocaleString('en-US');
  return formattedNumber;
}

export const validTapTicker = (data) => {
  if (data.length == 3 || (data.length >=5 && data.length <=32 )) {
    return true;
  }
  else return false;
}

export const convertTimestamp = (timestamp) => {
  const date = new Date(timestamp);

  // Extract components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');   // Months are 0-based in JavaScript
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Format to dd/mm/yyyy hh:mm:ss
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export const convertTimestampToDate = (timestamp) => {
  const date = new Date(timestamp);

  // Extract components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');   // Months are 0-based in JavaScript
  const year = date.getFullYear();

  // Format to dd/mm/yyyy hh:mm:ss
  return `${day}/${month}/${year}`;
}


export const reverseInscriptionId = (value) => {
  value = value.slice(0, 64);
  let temps = [];
  let result = "";
  for(let i = 0; i< 32; i++) {
    temps.push(value.slice(i * 2, (i + 1) * 2));
  }
  temps = temps.reverse();
  console.log(temps);
  for(let temp of temps ) {
    result = result + temp;
  }
  return result;
}

export const formatFloat = (value, decimal) => {
  return Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal) 
}

export const generateRandomKey = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
  }

  return result;
}

export const calculateMultiFee = (vins, vouts, recommendedFeeRate) => {
  if (typeof recommendedFeeRate !== "number" || recommendedFeeRate <= 0)
    throw new Error("Invalid fee rate.");

  const baseTxSize = 10;
  const inSize_Segwit = 67.5;
  const inSize_Taproot = 57.5;
  const inSize_Legacy = 147;
  const inSize_Nested_Segwit = 100;
  const outSize_Segwit = 32;
  const outSize_Taproot = 43.5;
  const outSize_Legacy = 34;
  const outSize_Nested_Segwit = 32;

  let vinsSeg = vins.seg ?? 0;
  let vinsTap = vins.tap ?? 0;
  let vinsLeg = vins.leg ?? 0;
  let vinsNesSeg = vins.nesSeg ?? 0;
  let voutsSeg = vouts.seg ?? 0;
  let voutsTap = vouts.tap ?? 0;
  let voutsLeg = vouts.leg ?? 0;
  let voutsNesSeg = vouts.nesSeg ?? 0;

  const txSize = baseTxSize + vinsSeg * inSize_Segwit + vinsTap * inSize_Taproot + vinsLeg * inSize_Legacy + vinsNesSeg * inSize_Nested_Segwit + voutsSeg * outSize_Segwit + voutsTap * outSize_Taproot + voutsLeg * outSize_Legacy + voutsNesSeg * outSize_Nested_Segwit;
  
  const fee = Math.round(txSize * recommendedFeeRate);
  return fee;
}

export const handleAddressUpdate = (data, address) => {
  if (address.trim().startsWith("1")) { // Legacy Address
    data.leg += 1;
  } else if (address.trim().startsWith("3")) { // Nested Segwit
    data.nesSeg += 1;
  } else if (address.trim().startsWith("bc1p")) { // Taproot
    data.tap += 1;
  } else if (address.trim().startsWith("bc1q")) { // Native Segwit
    data.seg += 1;
  }
  return data;
}

export const convertTo12HourFormat = (hour) => {
  let period = hour >= 12 ? 'PM' : 'AM';
  if (hour === 0) {
      hour = 12; // Midnight case
  } else if (hour > 12) {
      hour -= 12; // Convert hour greater than 12 to 12-hour format
  }
  return `${hour} ${period}`;
}

export const formatNumberWithCommas = (number) => {
  if (number < 1) return number;
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const checkValidBitcoinAddressLength = (address) => {
  if (address.length == 62) return true;
  else if (address.length == 34) return true;
  else if (address.length == 42) return true;
  else return false;
}